// Date input bounds — a CONVENIENCE mirroring the server's guard
// (src/helpers/dateGuard.js, census #78/#87/#89). The server check is the real
// one: the API is reachable without this form. Keep the numbers in step.
//
// 1940 comes from the data, not instinct: the earliest legitimate completion on
// file is 1979-06-20 and the oldest DOB 1961-04-24; the failure actually seen
// was a two-digit year ("26" read as the year 26) from an input with no floor.
import { etTodayISO } from './etTime';

export const DATE_FLOOR = '1940-01-01';
// Dates of birth get a wider floor, deliberately NOT tied to the unverified
// MAX_AGE constant (docs/COMPLIANCE-AND-LEGAL.md).
export const DOB_FLOOR = '1900-01-01';
export const EXPIRY_HORIZON_YEARS = 15;

// A completion date is the day the thing happened — never after today (ET).
export function completionMax() {
  return etTodayISO();
}

export function expiryMax() {
  const t = etTodayISO();
  return `${Number(t.slice(0, 4)) + EXPIRY_HORIZON_YEARS}${t.slice(4)}`;
}
